<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-form>
            <b-row>
              <!-- Field: fileData -->
              <b-col
                  cols="12"
              >

                <h2>بارگذاری اکسل نظرات</h2>

                <b-alert
                    :show="true"
                    variant="warning"
                    class="col-md-6 col-12"
                >
                  <div class="alert-body mt-2">
                    <p class="ml-25">-
                      لطفا ابتدا فایل نمونه اکسل را دانلود کرده و پر کنید سپس آن را ارسال کنید.
                      <a :href="baseURL+'excels/CommentExample.xlsx'" download class="text-primary">لینک دانلود فایل نمونه</a>
                    </p>
                    <p class="ml-25">-
                      بعد از بارگزاری فایل اکسل به شما گزارش داده می شود که چند مورد با موفقیت ثبت شده و چند مورد با خطا مواجه شده است.
                    </p>
                    <p class="ml-25">-
                      لطفا توجه کنید که در صورت بارگزاری مجدد فایل اکسل نظر تکراری ثبت خواهد شد.
                    </p>
                  </div>
                </b-alert>

                <b-button
                    class="mt-2 col-12 col-md-4"
                    variant="warning"
                    @click="$refs.refInputEl2.click()"
                >
                  <input
                      ref="refInputEl2"
                      type="file"
                      class="d-none"
                      @change="select"
                  >
                  <span class="">بارگذاری</span>
                </b-button>
                <b-button
                    variant="primary"
                    class="mt-2 mb-sm-0 ml-2   col-12 col-md-2"
                    :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                    @click="upload"
                >
                  ثبت
                </b-button>
              </b-col>
            </b-row>
          </b-form>

          <b-progress
              v-if="uploaded !== 0 && uploaded !== 100"
              :value="uploaded"
              max="100"
              variant="primary"
              class=" mt-2"
          />

          <b-alert
              :show="isSuccess === true"
              variant="success"
              class="col-md-2 col-12"
          >
            <div class="alert-body mt-2">
              <feather-icon
                  class="mr-25"
                  icon="CheckIcon"
              />
              <span class="ml-25">فایل شما آپلود شده است.</span>
            </div>
          </b-alert>
          <b-alert
              :show="isSuccess === false"
              variant="danger"
              class="col-md-2 col-12"
          >
            <div class="alert-body mt-2">
              <feather-icon
                  class="mr-25"
                  icon="CloseIcon"
              />
              <span class="ml-25">{{ errorMessage }}</span>
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>

  </b-overlay>
</template>

<script>
import {
  BAlert, BAvatar,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem, BForm, BFormGroup, BFormInput, BFormTextarea,
  BImg,
  BLink, BMedia, BOverlay,
  BRow, BTab, BTabs, BProgress, BModal, BCardTitle
} from "bootstrap-vue";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vSelect from "vue-select";
import axios from "axios";
import {getUserData} from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  ProductGetProductsMediasForAdminRequest,
  ProductSetMediaGroupTypeRequest,
  ProductSetReachableRequest
} from "@/libs/Api/Product";
import {MediaDeleteByPictureUrlRequest} from "@/libs/Api/Product";
import {MediaChangeMediaNameRequest, MediaChangePriorityRequest} from "@/libs/Api/Media";
import Helper from "@/libs/Helper";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {ArvanCloudVideoCreateRequest, DeleteArvanVideo} from "@/libs/Api/ArvanCloud";

export default {
  title: 'اکسل نظرات محصول - پنل ادمین ذهن آرایی',
  name: "ECommerceAddProductcomment",
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BMedia,
    BAvatar,
    BOverlay,
    vSelect,
    BProgress,
    AppCollapse,
    AppCollapseItem,
    BModal,
    BCardTitle,
    ValidationProvider, ValidationObserver
  },
  data() {
    return {
      productId: this.$route.params.id,
      errorMessage:null,
      isSuccess:null,
      userToken: getUserData().token,
      errorAlert: false,
      overlay: false,
      deleteItem: null,
      baseURL: Helper.baseUrl,
      file: null,
      chunks: [],
      uploaded: 0,
      namePictureURL: null,
      priorityPictureURL: null,
      newName: '',
      newPriority: '',
      uploadParentId: null,
      quality: null,
    };
  },
  // async created() {
  //   await this.getProductMedias();
  // },
  computed: {
    formData() {
      let formData = new FormData;
      if (this.file !== null) {
        formData.set('excelFile', this.file, `${this.file.name}`);
      }
      return formData;
    },
    config() {
      return {
        method: 'POST',
        data: this.formData,
        withCredentials:true,
        url: Helper.baseUrl+ 'api/ProductComment/CreateByExcel?productId=' + this.productId,
        headers: {
          'Content-Type': 'application/octet-stream',
          'Authorization': this.userToken,
        },
        onUploadProgress: progressEvent => {
          this.uploaded = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      };
    },
  },
  methods: {
    upload() {
      axios(this.config).then(response => {
        if (response.data.isSuccess){
          this.isSuccess = true;
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: response.data.errorMessage ? response.data.errorMessage : `فایل با موفقیت آپلود شد.`,
            },
          })
        }else {
          this.isSuccess = false;
          this.errorMessage = response.data.errorMessage;
          return this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `توجه`,
              icon: 'CloseIcon',
              variant: 'danger',
              text: response.data.errorMessage,
            },
          })
        }
      }).catch(error => {
        this.errorAlert = true;
        console.log(error);
      });
    },
    select(event) {
      this.file = event.target.files.item(0);
    },
  }
}
</script>

<style scoped>

</style>
